var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.75V26.25C30 26.6875 29.6562 27 29.25 27C28.8125 27 28.5 26.6875 28.5 26.25V26.0938L22.9375 24.5625C22.6562 25.9688 21.4375 27 20 27C18.3125 27 17 25.6562 17 24C17 23.6562 17.0312 23.3125 17.1562 23L13.5 22V22.25C13.5 22.6875 13.1562 23 12.75 23C12.3125 23 12 22.6875 12 22.25V17.75C12 17.3438 12.3125 17 12.75 17C13.1562 17 13.5 17.3438 13.5 17.75V18.0312L28.5 13.9375V13.75C28.5 13.3438 28.8125 13 29.25 13C29.6562 13 30 13.3438 30 13.75ZM28.5 24.5312V15.5L13.5 19.5938V20.4375L28.5 24.5312ZM20 25.5C20.75 25.5 21.4062 24.9375 21.4688 24.1875L18.625 23.4062C18.5312 23.5938 18.5 23.7812 18.5 24C18.5 24.8438 19.1562 25.5 20 25.5Z",
    fill: "#303340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingPlatform);
export default __webpack_public_path__ + "static/media/marketingPlatform.1621ac66ddfbcd9760f1ea8702404f9a.svg";
export { ForwardRef as ReactComponent };